export default {
	ListFixturesCommand: "ListFixturesCommand",
	FetchLeagueTableCommand: "FetchLeagueTableCommand",
	FetchIntegrationInfoCommand: "FetchIntegrationInfoCommand",
}
